import { Reveal } from "@/components/Reveal";

const STACK = [
  "A GAME PLAN.",
  "AN OPERATING SYSTEM.",
  "TRAINING.",
  "ANALYTICS.",
  "ACCOUNTABILITY.",
  "COMMUNITY.",
];

export default function WhyPeeExists() {
  return (
    <section id="why-pee" data-testid="why-pee-section" className="border-t border-line bg-[#070809] py-24 lg:py-32">
      <div className="mx-auto max-w-4xl px-4 sm:px-6">
        <Reveal>
          <div className="mb-5 flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.25em] text-neon/90">
            <span className="h-px w-8 bg-neon/50" />
            Why P.E.E. Exists
          </div>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="font-display text-3xl font-extrabold uppercase leading-[1.08] tracking-tight text-white sm:text-4xl lg:text-5xl">
            I wasn't looking
            <br />
            for another indicator.
            <br />
            I was trying to become
            <br />a <span className="glow-text-neon text-neon">better Executor.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.15}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-mist">
            Trading taught me something I didn't understand in the beginning:
            knowing what a good trade looks like doesn't automatically mean
            you'll execute it correctly. You can understand the setup and still
            hesitate. You can enter correctly and still exit from fear. You can
            have rules and still break them after a loss. You can know your risk
            and still become attached to the money.
          </p>
        </Reveal>

        <Reveal delay={0.2}>
          <p className="mt-6 max-w-2xl text-base text-white">
            Eventually, the question changed.
          </p>
        </Reveal>

        <div className="mt-10 grid gap-4 sm:grid-cols-2">
          <Reveal delay={0.25} className="h-full">
            <div className="flex h-full flex-col justify-between rounded-lg border border-line bg-charcoal/50 p-7">
              <span className="font-mono text-[9px] uppercase tracking-[0.25em] text-dim">
                Instead of constantly asking
              </span>
              <p className="mt-6 font-display text-xl font-bold uppercase leading-snug tracking-tight text-mist sm:text-2xl">
                “What will the
                <br />
                market do next?”
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.32} className="h-full">
            <div className="glow-neon flex h-full flex-col justify-between rounded-lg border border-neon/50 bg-charcoal p-7">
              <span className="font-mono text-[9px] uppercase tracking-[0.25em] text-neon/80">
                I became more interested in
              </span>
              <p className="mt-6 font-display text-xl font-extrabold uppercase leading-snug tracking-tight text-white sm:text-2xl">
                “What conditions
                <br />
                need to exist
                <br />
                <span className="text-neon">before I act?”</span>
              </p>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.35}>
          <p className="mt-10 max-w-2xl text-base leading-relaxed text-mist">
            That thinking eventually became:{" "}
            <span className="font-display text-lg font-extrabold uppercase tracking-tight text-white">
              Position. Event. Entry.
            </span>
          </p>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-mist">
            And as the methodology developed, another problem appeared: how do
            we organize the entire process—from opportunity identification to
            execution, validation, trade management, alerts, and analytics? That
            question led to{" "}
            <span className="font-display font-bold text-white">P.E.E. OS™.</span>
          </p>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-mist">
            But technology alone isn't enough. The trader still has to execute.
            That's why P.E.E. has grown into something larger than software.
          </p>
        </Reveal>

        <div className="mt-10 flex flex-wrap gap-2.5">
          {STACK.map((s, i) => (
            <Reveal key={s} delay={0.05 * i}>
              <span className="inline-block rounded-md border border-line bg-ink px-4 py-2 font-mono text-[11px] uppercase tracking-[0.16em] text-white">
                {s}
              </span>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.3}>
          <div className="mt-14 border-t border-line pt-10">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-dim">
              All built around one belief
            </p>
            <p className="glow-text-neon mt-4 font-display text-4xl font-extrabold uppercase leading-[1.05] tracking-tight text-neon sm:text-5xl">
              Execution
              <br />
              over everything.™
            </p>
            <div className="mt-10 flex items-center gap-4">
              <span className="flex h-11 w-11 items-center justify-center rounded-md border border-neon/40 bg-neon/10 font-display text-sm font-extrabold text-neon">
                BJ
              </span>
              <div>
                <div className="font-display text-base font-bold uppercase tracking-tight text-white">
                  Benjamin Diego John
                </div>
                <div className="mt-0.5 font-mono text-[9px] uppercase tracking-[0.22em] text-dim">
                  Founder — P.E.E. OS™ / Execution Traders Community
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
